<template>
  <div>
    <div class="gen_info pb-3">
      <div class="client_info mt-4 mb-4">
        <div style="display: flex; max-width: 91%;">
          <div class="thumb_client ml-4">
            <Thumbnail
              v-if="this.contact.name"
              size="55px"
              :username="contact.name"
              :src="contact.thumbnail"
            />
            <Thumbnail v-else src="N/A" size="55px" username="-- --" />
            <!--                    <span>
                        Since {{ contactDate }}
                    </span>-->
          </div>
          <div class="general_infomation">
            <div>
              <div class="details" style="display: flex">
                <span v-if="clientName" class="name" :class="{ 'conditional-max-width': clientAge > 0 }">{{ clientName }}</span>
                <span v-else-if="contact.name" class="name" :class="{ 'conditional-max-width': clientAge > 0 }">{{ contact.name }}</span>
                <span v-else class="name">Not known</span>
                <svg v-if="clientGender === 'Femme'" style="margin-right: 1rem;" width="15" height="15" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.64 14V11.84H1.28V10.9H3.64V9.14C2.96 9.04667 2.34667 8.80667 1.8 8.42C1.25333 8.03333 0.82 7.54 0.5 6.94C0.18 6.34 0.0200001 5.69333 0.0200001 5C0.0200001 4.25333 0.206667 3.57333 0.58 2.96C0.966667 2.33333 1.47333 1.83333 2.1 1.46C2.74 1.08667 3.43333 0.899999 4.18 0.899999C4.94 0.899999 5.63333 1.08667 6.26 1.46C6.9 1.83333 7.40667 2.33333 7.78 2.96C8.15333 3.57333 8.34 4.25333 8.34 5C8.34 5.68 8.18 6.32 7.86 6.92C7.54 7.52 7.10667 8.02 6.56 8.42C6.02667 8.80667 5.41333 9.04667 4.72 9.14V10.9H6.94V11.84H4.72V14H3.64ZM4.18 8.16C4.75333 8.16 5.28 8.02 5.76 7.74C6.24 7.44667 6.62 7.06 6.9 6.58C7.19333 6.1 7.34 5.57333 7.34 5C7.34 4.44 7.19333 3.92667 6.9 3.46C6.62 2.99333 6.24 2.62 5.76 2.34C5.28 2.04667 4.75333 1.9 4.18 1.9C3.60667 1.9 3.08 2.04667 2.6 2.34C2.12 2.62 1.73333 2.99333 1.44 3.46C1.16 3.92667 1.02 4.44 1.02 5C1.02 5.57333 1.16 6.1 1.44 6.58C1.73333 7.06 2.12 7.44667 2.6 7.74C3.08 8.02 3.60667 8.16 4.18 8.16Z" fill="black"></path>
                </svg>
                <svg v-else-if="clientGender === 'Homme'" style="margin-right: 1rem;" width="15" height="15" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.18 11C3.43333 11 2.74 10.8133 2.1 10.44C1.47333 10.0667 0.966667 9.56667 0.58 8.94C0.206667 8.3 0.0200001 7.6 0.0200001 6.84C0.0200001 6.09333 0.206667 5.41333 0.58 4.8C0.966667 4.17333 1.47333 3.67333 2.1 3.3C2.74 2.92667 3.43333 2.74 4.18 2.74C4.63333 2.74 5.06667 2.81333 5.48 2.96C5.89333 3.09333 6.28667 3.29333 6.66 3.56L8.52 1.48L6.94 0.699999L10.3 0.319999L10.32 3.7L9.34 2.2L7.44 4.32C7.74667 4.69333 7.97333 5.09333 8.12 5.52C8.26667 5.93333 8.34 6.37333 8.34 6.84C8.34 7.6 8.15333 8.3 7.78 8.94C7.40667 9.56667 6.9 10.0667 6.26 10.44C5.63333 10.8133 4.94 11 4.18 11ZM4.18 10C4.75333 10 5.28 9.86 5.76 9.58C6.24 9.28667 6.62 8.9 6.9 8.42C7.19333 7.94 7.34 7.41333 7.34 6.84C7.34 6.28 7.19333 5.76667 6.9 5.3C6.62 4.82 6.24 4.44 5.76 4.16C5.28 3.88 4.75333 3.74 4.18 3.74C3.60667 3.74 3.08 3.88 2.6 4.16C2.12 4.44 1.73333 4.82 1.44 5.3C1.16 5.76667 1.02 6.28 1.02 6.84C1.02 7.41333 1.16 7.94 1.44 8.42C1.73333 8.9 2.12 9.28667 2.6 9.58C3.08 9.86 3.60667 10 4.18 10Z" fill="black"/>
                </svg>
                <span v-if="clientAge > 0" class="age">({{ clientAge }})</span>
              </div>
            </div>
            <div v-if="clientEmail" v-tooltip="`${clientEmail}`" class="email">
                <span>{{ clientEmail }}</span>
            </div>
            <div v-if="clientPhoneNumber" class="phonenumber">
                <span>+216{{ clientPhoneNumber }}</span>
            </div>
            <div v-if="clientAddress" v-tooltip="`${clientAddress}`" class="city">
                <span>{{ clientAddress }}</span>
            </div>
          </div>
        </div>
        <div>
          <a :href="editUrl"
            target="_blank"
            rel="noreferrer noopener nofollow"
          >
            <svg
            id="edit"
            class="mr-4"
            v-tooltip="$t('EDIT_CONTACT.BUTTON_LABEL')"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            style="cursor: pointer;"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.2946 18.5578L4.29289 18.5562C3.90204 18.1879 3.69216 17.6108 3.76681 16.9463C3.76682 16.9462 3.76684 16.9461 3.76685 16.9459L4.13673 13.7071C4.13673 13.707 4.13674 13.707 4.13674 13.7069C4.13675 13.7069 4.13675 13.7068 4.13676 13.7068C4.16421 13.4679 4.25484 13.1654 4.39347 12.8669C4.53247 12.5676 4.70341 12.3075 4.86758 12.1395L4.86763 12.1396L4.87344 12.1334L13.0834 3.44342L13.0834 3.44341C14.0543 2.41577 14.9847 1.95232 15.8691 1.92735C16.7536 1.90238 17.7089 2.31263 18.7366 3.28351C19.7643 4.25432 20.2277 5.18473 20.2527 6.06916C20.2777 6.95365 19.8674 7.90897 18.8965 8.93669L10.6865 17.6267L10.6845 17.6289C10.3392 17.9988 9.65904 18.3647 9.1591 18.4466L9.1558 18.4472L5.9625 18.9926C5.88513 18.9975 5.82527 19.0027 5.77296 19.0072C5.68953 19.0145 5.62533 19.0201 5.53999 19.0201C5.04247 19.0201 4.6008 18.849 4.2946 18.5578ZM13.4465 3.76674L13.4463 3.76688L5.23792 12.4652C5.23762 12.4655 5.23733 12.4658 5.23703 12.4662C5.08276 12.6285 4.94835 12.8619 4.85189 13.0686C4.75434 13.2776 4.66435 13.5266 4.63468 13.7417L4.63454 13.7417L4.63322 13.7533L4.26362 16.9899C4.26354 16.9905 4.26347 16.9911 4.26339 16.9918C4.2111 17.4267 4.30841 17.8735 4.63667 18.1836C4.96741 18.4959 5.41493 18.558 5.83489 18.4944L5.8349 18.4945L5.84417 18.4929L9.06417 17.9429L9.06494 17.9428C9.28635 17.9046 9.53348 17.7991 9.73561 17.6904C9.93802 17.5815 10.16 17.4345 10.3121 17.2749L10.3134 17.2734L18.5234 8.58342L18.5244 8.58239C19.1594 7.90648 19.6904 7.16043 19.7428 6.29271C19.7969 5.39816 19.3382 4.53411 18.3845 3.63768C17.5397 2.82521 16.7322 2.41005 15.93 2.41005C14.94 2.41005 14.1433 3.02891 13.4465 3.76674Z"
              stroke="#483A9D"
            />
            <path
              d="M17.381 9.95745L17.3814 9.95749C17.5099 9.97003 17.6117 10.0873 17.603 10.2229C17.5817 10.3519 17.4645 10.4498 17.3399 10.4498H17.3398H17.3397H17.3396H17.3395H17.3394H17.3392H17.3391H17.339H17.3389H17.3388H17.3386H17.3385H17.3384H17.3383H17.3382H17.338H17.3379H17.3378H17.3377H17.3376H17.3374H17.3373H17.3372H17.3371H17.3369H17.3368H17.3367H17.3366H17.3365H17.3363H17.3362H17.3361H17.336H17.3358H17.3357H17.3356H17.3355H17.3353H17.3352H17.3351H17.335H17.3348H17.3347H17.3346H17.3345H17.3343H17.3342H17.3341H17.3339H17.3338H17.3337H17.3336H17.3334H17.3333H17.3332H17.3331H17.3329H17.3328H17.3327H17.3325H17.3324H17.3323H17.3321H17.332H17.3319H17.3318H17.3316H17.3315H17.3314H17.3312H17.3311H17.331H17.3308H17.3307H17.3306H17.3304H17.3303H17.3302H17.33H17.3299H17.3298H17.3297H17.3295H17.3294H17.3293H17.3291H17.329H17.3289H17.3287H17.3286H17.3284H17.3283H17.3282H17.328H17.3279H17.3278H17.3276H17.3275H17.3274H17.3272H17.3271H17.327H17.3268H17.3267H17.3266H17.3264H17.3263H17.3261H17.326H17.3259H17.3257H17.3256H17.3255H17.3253H17.3252H17.325H17.3249H17.3248H17.3246H17.3245H17.3244H17.3242H17.3241H17.3239H17.3238H17.3237H17.3235H17.3234H17.3232H17.3231H17.323H17.3228H17.3227H17.3225H17.3224H17.3223H17.3221H17.322H17.3218H17.3217H17.3216H17.3214H17.3213H17.3211H17.321H17.3209H17.3207H17.3206H17.3204H17.3203H17.3202H17.32H17.3199H17.3197H17.3196H17.3194H17.3193H17.3192H17.319H17.3189H17.3187H17.3186H17.3185H17.3183H17.3182H17.318H17.3179H17.3177H17.3176H17.3175H17.3173H17.3172H17.317H17.3169H17.3167H17.3166H17.3164H17.3163H17.3162H17.316H17.3159H17.3157H17.3156H17.3154H17.3153H17.3152H17.315H17.3149H17.3147H17.3146H17.3144H17.3143H17.3141H17.314H17.3138H17.3137H17.3136H17.3134H17.3133H17.3131H17.313H17.3128H17.3127H17.3125H17.3124H17.3123H17.3121H17.312H17.3118H17.3117H17.3115H17.3114H17.3112H17.3111H17.3109H17.3108H17.3107H17.3105H17.3104H17.3102H17.3101H17.3099H17.3098H17.3096H17.3095H17.3093H17.3092H17.309H17.3089H17.3088H17.3086H17.3085H17.3083H17.3082H17.308H17.3079H17.3077H17.3076H17.3074H17.3073H17.3071H17.307H17.3069H17.3067H17.3066H17.3064H17.3063H17.3061H17.306H17.3058H17.3057H17.3055H17.3054H17.3052H17.3051H17.3049H17.3048H17.3047H17.3045H17.3044H17.3042H17.3041H17.3039H17.3038H17.3036H17.3035H17.3033H17.3032H17.303H17.3029H17.3028H17.3026H17.3025H17.3023H17.3022H17.302H17.3019H17.3017H17.3016H17.3014H17.3013H17.3011H17.301H17.3008H17.3007H17.3006H17.3004H17.3003H17.3001H17.3H17.2998H17.2997H17.2995H17.2994H17.2992H17.2991H17.299H17.2988H17.2987H17.2985H17.2984H17.2982H17.2981H17.2979H17.2978H17.2976H17.2975H17.2974H17.2972H17.2971H17.2969H17.2968H17.2966H17.2965H17.2963H17.2962H17.296H17.2959H17.2958H17.2956H17.2955H17.2953H17.2952C14.4136 10.1526 12.0992 7.96071 11.6545 5.0959C11.6356 4.96146 11.7253 4.8313 11.8681 4.8038C12.0022 4.78727 12.1309 4.87817 12.1567 5.02159C12.5734 7.6634 14.7145 9.69517 17.381 9.95745Z"
              stroke="#483A9D"
            />
            <path
              d="M21 22.25H3C2.86614 22.25 2.75 22.1339 2.75 22C2.75 21.8661 2.86614 21.75 3 21.75H21C21.1339 21.75 21.25 21.8661 21.25 22C21.25 22.1339 21.1339 22.25 21 22.25Z"
              fill="#483A9D"
              stroke="#483A9D"
            />
          </svg>
          </a>
        </div>
        <!--                <div class="localisation_client">
                    <svg width="40" height="40" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path d="M0 27.75H25V2.75H0V27.75Z" fill="url(#pattern0)"/>
                        <circle cx="22" cy="7" r="6.5" fill="white" stroke="#EDECF6"/>
                        <path d="M22 7.90418C21.1125 7.90418 20.3875 7.18335 20.3875 6.29168C20.3875 5.40002 21.1125 4.68335 22 4.68335C22.8875 4.68335 23.6125 5.40418 23.6125 6.29585C23.6125 7.18752 22.8875 7.90418 22 7.90418ZM22 5.30835C21.4583 5.30835 21.0125 5.75002 21.0125 6.29585C21.0125 6.84168 21.4541 7.28335 22 7.28335C22.5458 7.28335 22.9875 6.84168 22.9875 6.29585C22.9875 5.75002 22.5416 5.30835 22 5.30835Z" fill="#292D32"/>
                        <path d="M22 11.4834C21.3833 11.4834 20.7625 11.25 20.2791 10.7875C19.05 9.60421 17.6916 7.71671 18.2041 5.47087C18.6666 3.43337 20.4458 2.52087 22 2.52087C22 2.52087 22 2.52087 22.0041 2.52087C23.5583 2.52087 25.3375 3.43337 25.8 5.47504C26.3083 7.72087 24.95 9.60421 23.7208 10.7875C23.2375 11.25 22.6166 11.4834 22 11.4834ZM22 3.14587C20.7875 3.14587 19.2291 3.79171 18.8166 5.60837C18.3666 7.57087 19.6 9.26254 20.7166 10.3334C21.4375 11.0292 22.5666 11.0292 23.2875 10.3334C24.4 9.26254 25.6333 7.57087 25.1916 5.60837C24.775 3.79171 23.2125 3.14587 22 3.14587Z" fill="#292D32"/>
                        <defs>
                            <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                                <use xlink:href="#image0_278_8312" transform="scale(0.015625)"/>
                            </pattern>
                            <image id="image0_278_8312" width="64" height="64" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAANb0lEQVR4nO2ba4xd1XXHf2vvc1/z8IzHNn5hjI152DgxRBUkBCKRGJXwKKWUpCkkpERtVbVKRRuSplKIGoUmRW2gEW1Ko4CqAqEtdUmRG7VIvNwk0LRNw6vGjomLscFjj2c8z3vP2Xutfjj33rlz78wYqN35gNfo3HPOPvvuvdZ/PfY+a90RM+OdTG6hGVhoOgnAQjOw0HQSgIVmYKHpJAALzcBC00kAFpqBhaZ3PABJe8Nfv+9SelauoNDVhXMecYKI4JxDzKBxTd6OgCB5e/0ewInklyI0GqXZBljbuY1EBJN8XFNFYYmarVDVVWq2XtUWq6k31ZKZJWY2ZtiomY2K2T6M3U5kv4jgcRBSpt4Y5Op/fmR+ABaERKbPIksNzlXsPIP1prrGYlyjMa6yEJaRhQIhIFlAYsQ0ghoGqIA5h3kHSTLkCsk+Vyg+J9496fFPiPd726f+/wdABBFy7TqWm8kmxd5lZucT47kS4yYJodtnARcCLguQprhaCo0jTdFaimaBaBGNSjQjCqgTNEmI5fIS6aoscb2951l35RM1M9Na7XvAJfMC4Lz/hHi/HeeGmpp5u4KSayT3E1lmwiaFLYZtIcYtksUNEkKfzzKSND8K1TQ/pxk+hFzgLEPTlJimxFpGyDJimhFjQGIghgimiBlan5tiAd9VodC7CNfbzRFMhkdHL25nswOA2ujYXxWXLB6Tcvlx8e5f8e55EV5B3F4xzUCQWWKAOQFxS0xYAaxWkbVqdpqZrUXjORLjuS7ELh9CU8AkTSnW0qbwLs1y0w4BYkSiEjUSQ4CoECNkAWJAY0Q1YqF+HSJqkUj99b5WRSanYKJKcaREyUE1ZB166gDg6J5X6MpCb2Hlymusu+saLZfQYkFd4veJ94Pi/JiYHXVYVZAyRgkoSrQV0Vgpqku8RiREXIz4EEmyQLEudDHNSLJAkmVIliEhQgwQDUxpTU9Y/UPEIWI58N6RhzXDMNQ5MEO84RTMDDUF8iBqMaIhoAVH9J2LXqcFTI5S3LWHniOjaG83Vi5h5bKzUmktxcJaCgl4jxOXrw6AmOGjkkQlCZFEI0kIeVuIeI24LAfEqeWrSf1oyttYLVpWEgNQrceN3KWkpUvjcAhWP1rvndSt1TlwDjE9NgBGgagBHTyMGzmKJAmuWMAXCkihgPM+P5zPmaqD4M1wajjLDwGcgWA5I3UBzQkmri6vo3VdbI84AijTXaYFt/q58de+ksoMgKSxDHeIPwsA+WRJjmgWsBAhTRERvHcgHpwD7+qmKYi4nDvnQBzmpY66gPP5qI1gWN9XiHeQRWxsAqtW8/vuLqSrK9e9WtMoTFqZz3UM2ibkdB/p+KTjek4AmlPUbU1cfjSxl4ZWch90+XKWA+AFxNW/45qbqNbVRJIEGx5BDx5EKhX8aWvwS9diaUD3HyC+vBu3qBd/6iosKlJ3knZttws27Q45f60Cd1rIPADMNngunzR90bncvxqmPbOtZfMnLWMmHskCYeeLFE9bR+XWT1O+YivJ+e/G9S3CzIi79pA+9T2m7n2Q7NlncWdsgCRBVDv4a+XRWp41zu1tc0Ew70ZoPqQb2phr6GY/AVdMsJGjxMH99Nz8K/Td/gX8ilNm9hfBnb2Bwtkb6P7UjYx+5jYm7vpzZN26+rLbOc9cbe157vl2M3O6wGx+1TBC12GMndA0eyQF9NBhbHiYgW/dQ8/NNwCQvbST6rZHyZ74PuHln+CWLqaw9SK6brqJwrs2sujO26FUYvSP7sCduWkeEWYHoZXmeN2YG4BO85ltAJsXBgBcAqNj6PAgSx/+Nt3XXQ3A6C2/z+S99xNG9+Hpp3zNVSQbN2CWUX3gYewXrqR4wXtY9NXbqD2+g9qPn0dWr0JinDMGvF2a1wJyMfN1FfLlrn0rMbcdgEQjDO5h8d1/Qfd1V6MhcORD11J9ejuOEj0f+zV6v/IF/NpTZ4wZ976a7/q8p/dLn6f64Z/P9w7z8DkfCPM9O2Y+oH0Ca3s21+BSKBBe3UXlw9fS95ufAuDIdZ+k9vRjePrp+fQt9D94T4fwAP7008B7AMqXf5Diz1yAHjx0LFbfFs0LQGMlnSvIwbR/dbjA2AS+3EPf3XcgwNjX/5LqPz6EKy2mdOkHWPSnfwhA9ZF/wo6ONse1qSo2Nj5jruLF78WmRvJ9xXGmN50RmsvnHLNYgXOEQ3spf/QjVNafTjZylPHbv4bvWQ3O0fv1rza7Tt13P6O/dWt+/cBDjP32Z7Fs5ktLctb6fJYTUMY8Zj7gzWDeHmUtRoQilY9eA8DUAw8TB1/FVQaoXH4Zhc3nNPsWL7qQ0d+7FRufZOqRbzPw2GO4gcUzeVi2FMhfeo43nZCEiI2Ok6xZR+HiC1Egffr7iHTB1CSFC9/T7Bf37iPd8QyuazkTj9xP/5fvpLT10lkGPHEV7OOfFBWw8TH8Wevxvb1EVeLefUhPN7iEZPNGCJGxz9zG4LozqG3/LsnGs3FUSH/0X7MOqQcHgThjS3286AQAIBg1/KqVOMDGxtGxcaRYBKsnNQSS8zbTd/c3KF9/HeG55yld8kFqf/8PHP2N38HSdMaQcdee+tjHndsTlRM0KBbymFUu47orxKhggezHL1D+ucup3PgRAMLLu6FSYeDJR9FDh0mf+WGHyafP/CdS6edE/Jjj+FuAASToyFEM8KUifs2p2MgI0j9AbftjM7rr4CEW/fEfgBPc8mWUr7kCKZVySwHSHT8g++G/405ZekJWgRMAgOEKXcTdP0VDQIDSlZehjOJXrSR99lnGb5teBns+/7tUfvWm5n14YSfpjmeawk7cdQ9gzY3RjKmYxuTtYnNCKkPS30fctYvw4k4M6Lrxeoqb30v20vMkZ57N+Jf/hLHPfQk98AbJlvxFx8bGGf/iV5i69/58J5h4ao/vYHLbNvzp65oWMZug7W3Hum+lEwNAuUysHqb6N9/Jd4alEgN/dy/+lJWE3c/jli1l8o67GHr/FQz/7PUMnX8pg2dtIez+CT1f/Cx+zSr08BAjN/46rm8AKyQd2m4Van5Q5reNYwLwtkzLFL94DZPf+CbZ4SEESM45k2U/eoquG26AxEHvIuLevdT+5QkM6Lv7Tvof/BbStwjUGL76l9HXD+JWr25qfzbejq1tmTVH0KA3vQrMhXj+ttje2XCLFxNeeZnhX/wky598NN8trlpB//3fJO5/nbDnp4j3+A3r8cuXNb+qQ8McufbjpM/8G4VzzyXWak1B249pEWfydZxdYH4bMPIcXDtzmmUk686i+tTjHLrqY3BkuDmZX72S0gcuovj+C2cIX/3Odzn8vstId/yAZNMmrKOQYbMCMB84x7LgeQGYL8I2Jpp3b2JKcsZGprZv5+AFWxm/6x6yPXtnjJv9zz4mH9rG0FW/xNC1HycOHibZfA4WsrzI0SiA0KghTIs5l2VIvd/MmDE7FHO6QGv1enqQzhx8a792DZgZxEhy1kbiwUGGb/kcydf+jMLZG3D9fejwCGHPXuJr+wHBn7EOSRK0Nq35Rg2lkzvq0NiMOadFl05+3goAjS84prFuR7kT9WnWpjE3LEuRZUtwpyzFJqeoPfsfSJZBoYj09uDXnQ7OYapYS8CbwbhNg2E2UzibcTV952e0voWscDtqQu7nDsVw9Wcyo6+19ZUGA5ZbTqOGL5UKrqu7jmCLYdZT361gNlKrjbKXQ9CWxGxeJYRWm5wtDjRGe0sWMJt/a0OoJs7thtYCQ11b0pLHkOY4htjMtoao+RvftIkHjICSoaSmpCgpgVQjsV4NVtOWGAEeqwM0nafOa5hvAYAGGw1ttpq41YVwc4jPHII3xnFIXu2FunYNNSOiZGpkZtTMqJpSjZFqDEzFyFSMTIZALQbSGImqqCpqETPDieINikAZo8ccfRbpMyVTobM0OmtxdJb0dtvzJpB1IVuKvXnckPyhkFeKnNTDpzS0mv+io1XQSY1MqDJeP09opGpKqkqqkVSVTJUs6mBUPRxVJ9RUTbWmppjZgJn1CvR4WJIAZVP6ojEQQCShKm+iPD6BcQSjjFFGSFpSo66hvbr/idXLYU1hpysFhhHJy/4RI5iSAlWMSVMm1RjTwIRGJs2Y1EjNlMwsC2avRHgR7BUzXsfsgKm+bqYHDDssyLBrxqBGrdgAygbdGba8hmyeMts8auHdbwQuqYgO9CaFYwMwjrGTwGGUxXh6zdNljhKRongK5Gbm1eGkXqH1dUuIShQhGgSDLEIVqJoxgTGJMqW5xmumBLOhCLsVXgJ7TpCdTnhRRF4rNEyMxg+gBK1Hf20JZ23ul08HQw5e8sjf5u5Gb4DLonHlMQGIcPMYduWIxa1ltK9MpKKOijgqRIomFHAUvMsrwyaoCkGEDMgEUjGyfCwygQAEs32G/DeOF0BecPCiCHscMtSI5HO53P+F8pjDmINtAtuOCYDAfR7ui0h/zbioKnHjiOkWj9vsVAacSI8X1+cCiRMxRMxEFJFhEw4ZvIbIARE5ILDfOfeaONnthV0eiY0fT81Wv1sIkpP/M/QOp5MALDQDC00nAVhoBhaaTgKw0AwsNJ0EYKEZWGg6CcBCM7DQ9L+bK6RL38iKJgAAAABJRU5ErkJggg=="/>
                        </defs>
                    </svg>
                </div>-->
      </div>
      <edit-contact
        v-if="showEditModal"
        :show="showEditModal"
        :contact="contact"
        @cancel="toggleEditModal"
      />
      <span class="header_title">{{
        $t('CONVERSATION_SIDEBAR.CURRENT_OPERATIONS')
      }}</span>
      <contract-type
        :client-contracts-count="clientContractsCount"
        :client-sinisters-count="clientSinistersCount"
        :client-claims-count="clientClaimsCount"
        :conversation-count="conversationCount"
      >
      </contract-type>
      <span class="header_title">{{
        $t('CONVERSATION_SIDEBAR.CONTACT_INFO.PHYSICAL_PERSON')
      }}</span>
      <assurance-ongoing-operations
        v-for="(item, index) in productFamilyObject"
        :item-key="item.key"
        :name="item.name"
        :count="item.count"
      >
      </assurance-ongoing-operations>
<!--      <span class="header_title">{{
        $t('CONVERSATION_SIDEBAR.CONTACT_INFO.PARTICULAR')
      }}</span>
      <contract-history></contract-history>
      <span class="header_title" style="color: #c4bfdf">{{
        $t('CONVERSATION_SIDEBAR.CONTACT_INFO.ENTREPRISES')
      }}</span>
      <assurance-preferances></assurance-preferances>-->
    </div>
    <!--                <AssuranceInfos></AssuranceInfos>-->
    <!--Conversation Actions .. -->
    <span class="accordion_title">{{
      $t('CONVERSATION_SIDEBAR.ACCORDION.CONVERSATION_ACTIONS')
    }}</span>
    <div class="conversation_act">
      <transition-group>
        <div
          v-for="element in conversationSidebarItems"
          :key="element.name"
          class="list-group-item"
        >
          <div
            v-if="element.name === 'conversation_actions'"
            class="conversation--actions"
          >
            <accordion-item
              :title="assignement"
              :is-open="isContactSidebarItemOpen('is_conv_actions_open')"
              @click="
                value => toggleSidebarUIState('is_conv_actions_open', value)
              "
            >
              <conversation-action
                :conversation-id="currentChat.id"
                :inbox-id="inboxId"
              />
            </accordion-item>
          </div>
        </div>
      </transition-group>
    </div>
    <div class="conversation_act">
      <transition-group>
        <div
          v-for="element in conversationSidebarItems"
          :key="element.name"
          class="list-group-item"
        >
          <div
            v-if="element.name === 'previous_conversation'"
            class="conversation--actions"
          >
            <accordion-item
              :title="$t('CONVERSATION_SIDEBAR.ACCORDION.CONVERSATION_LABELS')"
              :is-open="isContactSidebarItemOpen('is_previous_conv_open')"
              @click="
                value => toggleSidebarUIState('is_previous_conv_open', value)
              "
            >
              <conversation-labels :conversation-id="currentChat.id" />
              <!--                                    <contact-labels :contact-id="contact.id" class="contact-labels" />-->
            </accordion-item>
          </div>
        </div>
      </transition-group>
    </div>
    <div class="conversation_act">
      <transition-group>
        <div
          v-for="element in conversationSidebarItems"
          :key="element.name"
          class="list-group-item"
        >
          <div v-if="element.name === 'macros'">
            <accordion-item
              :title="$t('CONVERSATION_SIDEBAR.ACCORDION.MACROS')"
              :is-open="isContactSidebarItemOpen('is_macro_open')"
              compact
              @click="value => toggleSidebarUIState('is_macro_open', value)"
            >
              <macros-list
                :conversation-id="currentChat.id"
                :inbox-id="currentChat.inbox_id"
              />
            </accordion-item>
          </div>
        </div>
      </transition-group>
    </div>
    <div class="conversation_act">
      <transition-group>
        <div
          v-for="element in conversationSidebarItems"
          :key="element.name"
          class="list-group-item"
        >
          <div v-if="element.name === 'conversation_participants'">
            <accordion-item
              :title="$t('CONVERSATION_PARTICIPANTS.SIDEBAR_TITLE')"
              :is-open="isContactSidebarItemOpen('is_conv_participants_open')"
              @click="
                value =>
                  toggleSidebarUIState('is_conv_participants_open', value)
              "
            >
              <conversation-participant
                :conversation-id="currentChat.id"
                :inbox-id="inboxId"
              />
            </accordion-item>
          </div>
        </div>
      </transition-group>
    </div>
    <div class="conversation_att ">
      <transition-group>
        <div
          v-for="element in conversationSidebarItems"
          :key="element.name"
          class="list-group-item"
        >
          <div v-if="element.name === 'contact_attributes'">
            <accordion-item
              :title="$t('CONVERSATION_SIDEBAR.ACCORDION.CONTACT_ATTRIBUTES')"
              :is-open="isContactSidebarItemOpen('is_contact_attributes_open')"
              compact
              @click="
                value =>
                  toggleSidebarUIState('is_contact_attributes_open', value)
              "
            >
              <custom-attributes
                attribute-type="contact_attribute"
                attribute-class="conversation--attribute"
                class="even"
                :contact-id="contact.id"
              />
              <custom-attribute-selector
                attribute-type="contact_attribute"
                :contact-id="contact.id"
              />
            </accordion-item>
          </div>
        </div>
      </transition-group>
    </div>
    <div class="conversation_att ">
      <transition-group>
        <div
          v-for="element in conversationSidebarItems"
          :key="element.name"
          class="list-group-item"
        >
          <div v-if="element.name === 'conversation_attributes'">
            <accordion-item
              :title="$t('CONVERSATION_SIDEBAR.ACCORDION.CONVERSATION_ATTRIBUTES')"
              :is-open="isContactSidebarItemOpen('is_conversation_attributes_open')"
              compact
              @click="
                value =>
                  toggleSidebarUIState('is_conversation_attributes_open', value)
              "
            >
              <custom-attributes
                attribute-type="conversation_attribute"
                attribute-class="conversation--attribute"
                class="even"
                :contact-id="contact.id"
              />
              <custom-attribute-selector
                attribute-type="conversation_attribute"
                :contact-id="contact.id"
              />
            </accordion-item>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import AssuranceInfos from '../../../widgets/conversation/AssuranceBlock/AssuranceInfos';
import AssuranceOngoingOperations from '../../../widgets/conversation/AssuranceBlock/AssuranceOngoingOperations';
import ContractHistory from '../../../widgets/conversation/AssuranceBlock/ContractHistory';
import ContractType from '../../../widgets/conversation/AssuranceBlock/ContractType';
import AssurancePreferances from '../../../widgets/conversation/AssuranceBlock/AssurancePreferances';
import ConversationLabels from '../../../../routes/dashboard/conversation/labels/LabelBox';
import Thumbnail from '../../Thumbnail';
import ConversationAction from '../../../../routes/dashboard/conversation/ConversationAction';
import ContactInfo from '../../../../routes/dashboard/conversation/contact/ContactInfo';
import ContactConversations from '../../../../store/modules/contactConversations';
import ConversationInfo from '../../../../routes/dashboard/conversation/ConversationInfo';
import CustomAttributes from '../../../../routes/dashboard/conversation/customAttributes/CustomAttributes';
import CustomAttributeSelector from '../../../../routes/dashboard/conversation/customAttributes/CustomAttributeSelector';
import AccordionItem from '../../../Accordion/AccordionItem';
import alertMixin from '../../../../../shared/mixins/alertMixin';
import uiSettingsMixin from '../../../../../dashboard/mixins/uiSettings';
import ContactLabels from '../../../../routes/dashboard/contacts/components/ContactLabels.vue';
import MacrosList from '../../../../routes/dashboard/conversation/Macros/List.vue';
import ConversationParticipant from '../../../../routes/dashboard/conversation/ConversationParticipant.vue';
import EditContact from '../../../../routes/dashboard/conversation/contact/EditContact.vue';
export default {
  name: 'ClientInformations',
  components: {
    EditContact,
    ContactLabels,
    ContactInfo,
    ConversationAction,
    Thumbnail,
    AssuranceOngoingOperations,
    draggable,
    AccordionItem,
    ContactConversations,
    ConversationInfo,
    CustomAttributes,
    CustomAttributeSelector,
    ConversationLabels,
    MacrosList,
    ConversationParticipant,
    AssuranceInfos,
    ContractHistory,
    AssurancePreferances,
    ContractType,
  },
  mixins: [alertMixin, uiSettingsMixin],
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
    onToggle: {
      type: Function,
      default: () => {},
    },
    clientGender: {
      type: String,
      default: '',
    },
    clientAge: {
      type: Number,
      default: 0,
    },
    clientPhoneNumber: {
      type: String,
      default: '',
    },
    clientAddress: {
      type: String,
      default: '',
    },
    clientName: {
      type: String,
      default: '',
    },
    clientEmail: {
      type: String,
      default: '' ,
    },
    editUrl: {
      type: String,
      default: '',
    },
    clientContractsCount: {
      type: Number,
      default: 0,
    },
    clientSinistersCount: {
      type: Number,
      default: 0,
    },
    clientClaimsCount: {
      type: Number,
      default: 0,
    },
    clientAutomobileContractsCount: {
      type: Number,
      default: 0,
    },
    clientIncendieContractsCount: {
      type: Number,
      default: 0,
    },
    clientTransportContractsCount: {
      type: Number,
      default: 0,
    },
    clientVarRisksContractsCount: {
      type: Number,
      default: 0,
    },
    clientHealthContractsCount: {
      type: Number,
      default: 0,
    },
    clientLifeContractsCount: {
      type: Number,
      default: 0,
    },
    clientSpecialRisksContractsCount: {
      type: Number,
      default: 0,
    },
    clientRcContractsCount: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      dragEnabled: true,
      conversationSidebarItems: [],
      dragging: false,
      assignement: 'Assignement',
      showEditModal: false,
    };
  },
  methods: {
    onPanelToggle() {
      this.onToggle();
    },
    getContactDetails() {
      if (this.contactId) {
        this.$store.dispatch('contacts/show', { id: this.contactId });
      }
    },
    getAttributesByModel() {
      if (this.contactId) {
        this.$store.dispatch('contacts/show', { id: this.contactId });
      }
    },
    openTranscriptModal() {
      this.showTranscriptModal = true;
    },

    onDragEnd() {
      this.dragging = false;
      this.updateUISettings({
        conversation_sidebar_items_order: this.conversationSidebarItems,
      });
    },
    toggleEditModal() {
      this.showEditModal = !this.showEditModal;
    },
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      uiFlags: 'inboxAssignableAgents/getUIFlags',
    }),
    contactDate() {
      /* to verify if there is a current workflow in the chat */
      if (
        this.contact.custom_attributes.workflow !== '' &&
        this.contact.custom_attributes.workflow !== undefined
      ) {
        return new Date().getFullYear();
      } else if (!this.contact.hasOwnProperty('created_at')) {
        return new Date().getFullYear();
      } else {
        const dateSec = parseInt(this.contact.created_at);
        /* convert dateSec to milliseconds */
        const dateMSec = dateSec * 1000;
        /* return date object */
        const createdYear = new Date(dateMSec).getFullYear();
        return createdYear;
      }
    },
    inboxId() {
      return this.currentChat?.inbox_id;
    },
    channelType() {
      return this.currentChat.meta?.channel;
    },
    conversationAdditionalAttributes() {
      return this.currentConversationMetaData.additional_attributes || {};
    },
    /*contact() {
      return this.$store.getters['contacts/getContact'](this.contactId);
    },*/
    contactAdditionalAttributes() {
      return this.contact.additional_attributes || {};
    },
    contactId() {
      return this.currentChat.meta?.sender?.id;
    },
    currentConversationMetaData() {
      return this.$store.getters[
        'conversationMetadata/getConversationMetadata'
      ](this.conversationId);
    },
    hasContactAttributes() {
      const { custom_attributes: customAttributes } = this.contact;
      return customAttributes && Object.keys(customAttributes).length;
    },
    productFamilyObject() {
      const productObject = [{key: 1, name: this.$t('CONVERSATION_SIDEBAR.PRODUCT_FAMILY.AUTOMOBILE'), count: this.clientAutomobileContractsCount},
        {key: 3, name: this.$t('CONVERSATION_SIDEBAR.PRODUCT_FAMILY.INCIDENCE'), count: this.clientIncendieContractsCount},
        {key: 4, name: this.$t('CONVERSATION_SIDEBAR.PRODUCT_FAMILY.TRANSPORT'), count: this.clientTransportContractsCount},
        {key: 5, name: this.$t('CONVERSATION_SIDEBAR.PRODUCT_FAMILY.VARIOUS_RISKS'), count: this.clientVarRisksContractsCount},
        {key: 6, name: this.$t('CONVERSATION_SIDEBAR.PRODUCT_FAMILY.HEALTH'), count: this.clientHealthContractsCount},
        {key: 7, name: this.$t('CONVERSATION_SIDEBAR.PRODUCT_FAMILY.LIFE'), count: this.clientLifeContractsCount},
        {key: 8, name: this.$t('CONVERSATION_SIDEBAR.PRODUCT_FAMILY.SPECIAL_RISKS'), count: this.clientSpecialRisksContractsCount},
        {key: 9, name: this.$t('CONVERSATION_SIDEBAR.PRODUCT_FAMILY.RC'), count: this.clientRcContractsCount}
      ]
      return productObject;
    },
    conversationCount() {
      return this.contact.nb_cin_updated ;
    }
  },
  watch: {
    conversationId(newConversationId, prevConversationId) {
      if (newConversationId && newConversationId !== prevConversationId) {
        this.getContactDetails();
      }
    },
  },
  mounted() {
    this.conversationSidebarItems = this.conversationSidebarItemsOrder;
    this.$store.dispatch('attributes/get', 0) ;
  },
};
</script>

<style scoped lang="scss">
@import '~dashboard/assets/scss/variables';

@media screen and (max-width: 1620px) {
  .name{
    max-width: 44%;
  }
  .city, .email {
    max-width: 70%;
  }
}

@media screen and (min-width: 1621px) {
  /*.name {
    max-width: 69%;
  }*/
  .conditional-max-width {
    max-width: 69%;
  }
  .city, .email {
    max-width: 100%;
  }
}

.gen_info {
  background: #f0eff7;
  border-radius: 8px;
  padding: 2px;
  margin: 10px;

  .client_info {
    display: flex;
    justify-content: space-between;
  }

  .header_title {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #483a9d;
    margin-bottom: 12px;
    margin-top: 12px;
    margin-left: 1.2rem;
  }

  .thumb_client {
    /* background-color: #483A9D;*/
    margin-top: -0.6rem;
    border-top-right-radius: 120px 130px;
    border-top-left-radius: 120px 130px;
    border-bottom-right-radius: 40px 40px;
    border-bottom-left-radius: 40px 40px;

    span {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 9px;
      line-height: 12px;
      color: #ffffff;
      margin-left: 4px;
    }
  }

  .general_infomation {
    margin-left: 1rem;
    .name {
      text-transform: capitalize;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      font-size: 15px;
      line-height: 19px;
      color: #000000;
      margin-right: 1rem;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      /*width: 72%;*/ /*44*/
    }

    .gender {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 24px;
      color: #000000;
    }

    .age {
      font-weight: 500;
      font-size: 13px;
      color: #000000;
      /*font-family: 'Inter';
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      color: #000000;
      margin-left: 8px !important;*/
    }

    .email, .phonenumber, .city {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      color: #000000;
      display: block;
      /*width: 70%;*/
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .localisation_client {
    display: flex !important;
    margin-right: 6px;
    margin-top: -5px;
  }
}

.btn_grp {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.position_svg {
  margin-left: -10px;
  z-index: 1;
}

.conversation_act {
  padding: 5px 14px !important;
}

.conversation_att {
  padding: 5px 14px !important;
  margin-bottom: 0.5rem !important;
}

.contact--panel {
  background: white;
  border-left: 1px solid var(--color-border);
  font-size: $font-size-small;
  overflow-y: auto;
  overflow: auto;
  position: relative;

  i {
    margin-right: $space-smaller;
  }
}

.list-group {
  .list-group-item {
    background-color: var(--white);
  }
}

::v-deep {
  .contact--profile {
    padding-bottom: var(--space-slab);
    border-bottom: 1px solid var(--color-border);
  }

  .conversation--actions .multiselect-wrap--small {
    .multiselect {
      padding-left: var(--space-medium);
      box-sizing: border-box;
    }

    .multiselect__element {
      span {
        width: 100%;
      }
    }
  }
}

.close-button {
  position: absolute;
  right: $space-two;
  top: $space-slab;
  font-size: $font-size-default;
  color: $color-heading;
  z-index: 9989;
}

.conversation--labels {
  padding: $space-medium;

  .icon {
    margin-right: $space-micro;
    font-size: $font-size-micro;
    color: #fff;
  }

  .label {
    color: #fff;
    padding: 0.2rem;
  }
}

.contact--mute {
  color: $alert-color;
  display: block;
  text-align: left;
}

.contact--actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.contact-info {
  margin-top: var(--space-two);
}

.accordion_title {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 30px;
  color: #656877;
  margin: 15px;
}
</style>
